/* eslint-disable */
import React from 'react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

// set up nonce
__webpack_nonce__ = window.app.nonce;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<React.StrictMode>
    <App />
</React.StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
